import React from "react";

const PERSON_FIELDS = [["last_name", "Cognome"], ["first_name", "Nome"], ["fiscal_code", "Codice fiscale"], ["birth_place", "Nato/a a"], ["birth_province", "Provincia di nascita"], ["birth_date", "Data di nascita"], ["residence_city", "Residente in (comune)"], ["residence_province", "Provincia di residenza"], ["address", "Indirizzo di residenza"], ["cap", "C.A.P."], ["email", "Email"], ["phone", "Telefono"], ["pec", "PEC"]];
const COMPANY_FIELDS = [["company_legal_name", "Ragione sociale"], ["company_vat", "Partita IVA"], ["sdi_code", "Codice destinatario SDI"], ["company_pec", "PEC società"], ["company_address", "Indirizzo sede legale"], ["company_city", "Sede (comune)"], ["company_province", "Provincia sede"], ["cciaa", "Iscritta alla C.C.I.A.A. di"], ["cciaa_province", "Provincia C.C.I.A.A."], ["email", "Email"], ["company_phone", "Telefono"]];
const REP_FIELDS = [["rep_last_name", "Cognome legale rappresentante"], ["rep_first_name", "Nome legale rappresentante"], ["rep_role", "In qualità di"], ["rep_fiscal_code", "Codice fiscale rappresentante"], ["rep_birth_place", "Nato/a a"], ["rep_birth_date", "Data di nascita"], ["rep_residence", "Residenza"]];
const LEGACY_FIELDS = [["fiscal_code", "Codice fiscale / P. IVA"], ["email", "Email"], ["phone", "Telefono"], ["address", "Indirizzo"], ["pec", "PEC"], ["company_name", "Ditta / Società"], ["company_vat", "Codice fiscale / P. IVA ditta"], ["role_in_company", "In qualità di (ruolo in ditta)"]];
const DATE_KEYS = ["birth_date", "rep_birth_date"];

export const CLIENT_KEYS = [...new Set(["person_type", "name", "contact", "status",
  ...PERSON_FIELDS, ...COMPANY_FIELDS, ...REP_FIELDS, ...LEGACY_FIELDS].map(field => Array.isArray(field) ? field[0] : field))];

const splitName = value => {
  const parts = String(value || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return { last_name: parts.join(" "), first_name: "" };
  return { first_name: parts[0], last_name: parts.slice(1).join(" ") };
};

export const ClientForm = ({ draft, setDraft }) => {
  const kind = draft.person_type || "";
  const set = (key, value) => setDraft(d => ({ ...d, [key]: value }));
  function changeKind(value) {
    setDraft(d => {
      const next = { ...d, person_type: value };
      if (value === "fisica" && !d.first_name && !d.last_name && d.name) Object.assign(next, splitName(d.name));
      if (value === "giuridica") {
        if (!d.company_legal_name) next.company_legal_name = d.company_name || d.name || "";
        if (!d.rep_role) next.rep_role = "Legale rappresentante";
      }
      return next;
    });
  }
  const fields = list => list.map(([key, label]) => <label key={key}>{label}
    <input type={DATE_KEYS.includes(key) ? "date" : "text"} required={["last_name", "company_legal_name"].includes(key)} data-testid={`directory-${key}`} value={draft[key] || ""} onChange={e => set(key, e.target.value)} />
  </label>);
  return <>
    <label>Tipo di soggetto
      <select data-testid="directory-person-type" value={kind} onChange={e => changeKind(e.target.value)}>
        <option value="">Da definire</option>
        <option value="fisica">Persona fisica</option>
        <option value="giuridica">Persona giuridica / Società</option>
      </select>
    </label>
    {kind === "" && <>
      <p className="practice-notice" data-testid="directory-person-hint">Scegli il tipo di soggetto per compilare i campi corretti nei documenti. I dati già inseriti restano invariati.</p>
      <label>Nome visualizzato<input required data-testid="directory-name" value={draft.name || ""} onChange={e => set("name", e.target.value)} /></label>
      {fields(LEGACY_FIELDS)}
    </>}
    {kind === "fisica" && <fieldset className="practice-fieldset"><legend>Dati della persona fisica</legend><div className="practice-form-grid">
      {fields(PERSON_FIELDS)}
    </div>
      <p className="practice-notice" data-testid="directory-name-preview">Nome visualizzato: <b>{[draft.last_name, draft.first_name].filter(Boolean).join(" ") || "Cognome Nome"}</b> — l'anagrafica usa sempre prima il cognome, così ordinamenti e filtri partono da lì.</p>
    </fieldset>}
    {kind === "giuridica" && <>
      <fieldset className="practice-fieldset"><legend>Dati della società</legend><div className="practice-form-grid">{fields(COMPANY_FIELDS)}</div></fieldset>
      <fieldset className="practice-fieldset"><legend>Legale rappresentante</legend><div className="practice-form-grid">{fields(REP_FIELDS)}</div></fieldset>
    </>}
  </>;
};
